import React, { useState, useEffect } from "react"
import { render } from "react-dom"

import App from "./App"

import "./index.css"

import * as serviceWorker from "./utils/serviceWorker"

function StoriesProvider({ children }) {
	const [stories, setStories] = useState([])

	useEffect(() => {
		async function fetchStories() {
			const response = await fetch(
				"https://byebye-stories.netlify.app/index.json",
				{
					mode: "cors",
					cache: "no-cache",
				},
			)
			if (response.status === 200) {
				const json = await response.json()
				if (json.length > 0) {
					setStories(json.filter((s) => !s.disabled))
				}
			}
		}
		fetchStories()
	}, [])

	if (stories.length === 0) return false

	return children(stories)
}

render(
	<React.StrictMode>
		<StoriesProvider>{(stories) => <App stories={stories} />}</StoriesProvider>
	</React.StrictMode>,
	document.getElementById("root"),
)

serviceWorker.unregister()
